import { render } from "./Votes.vue?vue&type=template&id=0441ffe0&ts=true"
import script from "./Votes.vue?vue&type=script&lang=ts"
export * from "./Votes.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__